// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__-Jrif","stat":"Stats_stat__IMXvZ","achievement":"Stats_achievement__Ln38p","circle":"Stats_circle__s4FSi"};